var _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 598,
    height: 503,
    viewBox: "0 0 598 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 192.5,
    r: 186,
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 13,
    strokeDasharray: "30 30"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 422,
    cy: 327,
    r: 169.5,
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 13,
    strokeDasharray: "30 30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCircle);
export default __webpack_public_path__ + "static/media/DoubleCircle.855c03e31ec56f513286c12494ca0ef5.svg";
export { ForwardRef as ReactComponent };